export default __webpack_public_path__ + "static/media/discover.6f5c6254.png";